import { Box, CircularProgress } from "@mui/material";
import { useIntl } from "react-intl";
import { HiddenText } from "foundations/HiddenText/HiddenText";

interface CenteredLoadingProps {
  minHeight?: number;
  ariaLabel?: string;
}

export function CenteredLoading(props: CenteredLoadingProps) {
  const intl = useIntl();

  const label =
    props.ariaLabel ??
    intl.formatMessage({
      defaultMessage: "Loading",
      description: "Status announcement for the loading spinner",
    });

  return (
    <Box
      role="status"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: props.minHeight ?? 250,
        height: "100%",
      }}
    >
      <HiddenText>{label}</HiddenText>
      <CircularProgress aria-hidden />
    </Box>
  );
}
